import MessageWindow from './msgWin';
export default MessageWindow;
// const ShippingCityComp = () => import('./MessageWindow');

// export {
//     ShippingCityComp,
// }



// WEBPACK FOOTER //
// ./src/components/messageWindow/index.js